/* eslint-disable react/function-component-definition */
import NotFound from "../components/errors/NotFound";

export default NotFound;
